module.exports = __webpack_public_path__ + "files/b822b2e3ceba231835c9aae9ce0cd61d.png";